import { trackPageView } from './GoogleAnalytics';

const trackPageViewGoogle: (pageTitle: string, pagePath: string) => void = (pageTitle, pagePath) => {
  trackPageView(pageTitle, pagePath);
};

export default trackPageViewGoogle;
